'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "Body": "Polaris-Modal__Body",
  "NoScrollBody": "Polaris-Modal__NoScrollBody",
  "IFrame": "Polaris-Modal__IFrame"
};

exports.default = styles;
